// Update the allowed values in the settings heartbeat
export enum ThemeTypes {
    Duotone = 0,
    Carbon = 1,
    Snow = 2,
    Monokai = 3,
    ContrastLight = 4,
    Legacy = 5,
    Classic = 6,
    ContrastDark = 7,
    PassDark = 8,
    Storefront = 9,
    WalletLight = 10,
    StorefrontWallet = 11,
    PassLight = 12,
    WalletDark = 13,
    LumoLight = 14,
    LumoDark = 15,
}

export enum ThemeModeSetting {
    Auto = 0,
    Dark = 1,
    Light = 2,
}

export enum ColorScheme {
    Dark = 0,
    Light = 1,
}

export enum MotionModeSetting {
    No_preference = 0,
    Reduce = 1,
}

export enum ThemeFontSizeSetting {
    DEFAULT = 0,
    X_SMALL = 1,
    SMALL = 2,
    LARGE = 3,
    X_LARGE = 4,
}

export enum ThemeFontFaceSetting {
    DEFAULT = 0,
    SYSTEM = 1,
    ARIAL = 2,
    TIMES = 3,
    DYSLEXIC = 4,
    ATKINSON = 5,
}

export enum ThemeFeatureSetting {
    DEFAULT = 0,
    SCROLLBARS_OFF = 1,
    ANIMATIONS_OFF = 2,
}
